<title>{{ errorResponseNdcTechnicalPage.htmlTitle }}</title>
<app-banner [banner]="errorResponseNdcTechnicalPage.banner"></app-banner>
<div class="container faq-disruption-notifications">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [param]="param" [sections]="errorResponseNdcTechnicalPage.sections"></app-border-section>
</div>
